//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import contentSourceBadgeTemplate from '@legacy-components/common/content-source-badge/content-source-badge.html';
import userImage from '@images/icons/user.svg';
import hashtag2Image from '@images/icons/hashtag-2.svg';

(function() {
  const discover = angular.module('curalate');

  discover.component('contentSourceBadge', {
    template: contentSourceBadgeTemplate,
    bindings: {
      avatarUrl: '<',
      maintitle: '<',
      subtitle: '<',
      sourceType: '<',
      dependency: '<',
      metadata: '<?',
      disableLink: '<?',
      onClick: '&?',
      hrefLink: '<?',
      followers: '<',
      hideUploaded: '@?',
      routeToExternal: '<',
      network: '<?',
    },
    controller: [
      'ContentSourceTypes',
      function(ContentSourceTypes) {
        const self = this;

        self.SOURCE_TYPE_UPLOAD = ContentSourceTypes.UPLOAD;

        this.$onInit = function() {
          switch (self.sourceType) {
            case ContentSourceTypes.USER: {
              self.sourceIcon = userImage;
              break;
            }
            case ContentSourceTypes.HASHTAG: {
              self.sourceIcon = hashtag2Image;
              break;
            }
            case ContentSourceTypes.UPLOAD: {
              self.titleFirstLetter = _(self).safeGet('maintitle.0');
              self.emailHash = _(self).safeGet('metadata.emailHash');
              break;
            }
            default: {
                            // no-op
            }
          }
        };
      },
    ],
  });
})();
